module.exports = __webpack_public_path__ + "img/checklist.c3a61966.svg";